import { render } from "./CaretIcon.vue?vue&type=template&id=0ea3d449&scoped=true"
import script from "./CaretIcon.vue?vue&type=script&lang=js"
export * from "./CaretIcon.vue?vue&type=script&lang=js"

import "./CaretIcon.vue?vue&type=style&index=0&id=0ea3d449&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea3d449"]])

export default __exports__